import { LocationVarKey, URLS } from "@swivl-mono/types";

import { SearchableLabel } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { TOPIC_VARS_BY_ID } from "../../../Views/Properties/CortexV3/Topics";
import { CortexTopicWorksheet } from "../Components/CortexTopicWorksheet";

export const PAGE_KEYS: LocationVarKey[] = TOPIC_VARS_BY_ID["urls"] ?? [];

export const SEARCH_LABELS: SearchableLabel[] = URLS.map((u) => ({ title: u.label, snippet: u.description }));

export default function URLsPage(): React.ReactElement {
  return (
    <CortexTopicWorksheet
      topicId="urls"
      heading="URLs"
      description="External links the bot can share with customers, like paying online or signing in."
      sectionEditing
    />
  );
}
